/**
 * 接口权限接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InterfacePermissionsService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 接口权限接口
  /**
   * 加载接口权限数据
   * @param param
   * @returns {Observable<any>}
   */
  queryControlPageList(param) {
    const url = this.prefix + 'control/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 加载接口权限数据
   * @param param
   * @returns {Observable<any>}
   */
  queryControlsByCode(param) {
    const url = this.prefix + 'control/queryControlsByCode'+param;
    return this.http.Post(url, null);
  }
  /**
   * 保存或删除接口权限 
   * @param param
   */
  saveOrDelete(param) {
    const url = this.prefix + 'functionControl/saveOrDelete';
    return this.http.Post(url, param);
  }

  /**
   * 接口权限
   * @param param
   */
  queryByFk(param) {
    const url = this.prefix + 'functionControl/queryByFk';
    return this.http.Post(url, param);
  }

  //#endregion


}
